/**
 * External URLs and copy for the portal home dashboard.
 * Override with REACT_APP_* env vars (see env.example).
 */

function trim(s) {
  return String(s || '').trim();
}

export function getIcctPublicSiteBase() {
  return trim(process.env.REACT_APP_ICCT_PUBLIC_SITE_URL) || 'https://icctmemphis.org';
}

/** Quick links and campaign landing URLs */
export function getPortalQuickLinks() {
  const b = getIcctPublicSiteBase().replace(/\/$/, '');
  return {
    donate: trim(process.env.REACT_APP_PORTAL_LINK_DONATE) || '/donate',
    poojaBooking: trim(process.env.REACT_APP_PORTAL_LINK_POOJA_BOOKING) || `${b}/pooja-booking`,
    poojaMaterials: trim(process.env.REACT_APP_PORTAL_LINK_POOJA_MATERIALS) || `${b}/pooja-materials`,
    calendar: trim(process.env.REACT_APP_PORTAL_LINK_CALENDAR) || `${b}/calendar`,
    facilityRentals: trim(process.env.REACT_APP_PORTAL_LINK_FACILITY_RENTALS) || `${b}/facility-rentals`,
    kotilingaInfo: trim(process.env.REACT_APP_PORTAL_LINK_KOTILINGA) || `${b}/kotilinga`,
    poshakaStore: trim(process.env.REACT_APP_PORTAL_LINK_POSHAKA_STORE) || `${b}/store/products/`,
    poshakaAbout: trim(process.env.REACT_APP_PORTAL_LINK_POSHAKA_ABOUT) || `${b}/about-temple/poshaka-parivar/`,
    annadanamInfo: trim(process.env.REACT_APP_PORTAL_LINK_ANNADANAM) || `${b}/give`,
  };
}

export const KOTILINGA_SHARE = {
  title: 'ICCT Kotilinga — a global, unique seva opportunity',
  text:
    'India Cultural Center and Temple (ICCT) is building a rare Kotilinga initiative. Learn how you can sponsor and share the blessing with friends and family.',
};
